<template>
  <div>
    <data-list class="select_checkbox_column_width_0" :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="800" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference">
        <template slot="extraDetails" v-if="modelObj.send_auto_reply">
          <v-container fluid :key="reInit">
            <v-layout wrap class="ma-0 pa-0">
            <v-flex lg12 xs12>
              <p>{{$t('message.settings.autoReply')}}</p>
              <ckeditor :editor="editor" v-model="modelObj.auto_reply" :config="editorConfig" ref="editor"></ckeditor>
            </v-flex>
            </v-layout>
          </v-container>
        </template>
      </form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '../../components/DataList.vue'
import FormTemplate from '../../components/FormTemplate'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: {
        isactive: true,
        color: null
      },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        page: 1,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      editor: Editor,
      editorConfig: {
        removePlugins: ['ImageUpload']
      },
      reInit: 0,
      loading: false,
      MODULE_URL: 'ticketstatuslists',
      pagination: !this.$formatter.isEmptyObject(this.$store.state.TICKETSTATUS_INDEX) ? this.$store.state.TICKETSTATUS_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' }
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '25%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }, {
        text: this.$t('message.common.isDefault'),
        value: 'isdefault',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }, {
        text: this.$t('message.ticketStatus.canClose'),
        value: 'canclose',
        isBoolean: true,
        sortable: false,
        width: '10%'
      }, /* {
        text: this.$t('message.common.position'),
        value: 'position',
        sortable: true,
        width: '10%'
      },  */{
        text: this.$t('message.common.color'),
        value: 'color',
        sortable: true,
        width: '20%'
      }, {
        text: this.$t('message.settings.sendAutoReply'),
        value: 'send_auto_reply',
        dbRef: 'Send_Auto_Reply',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }]
    },
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.ticketStatus.updateTicketStatus') : this.$t('message.ticketStatus.addTicketStatus'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'md4 xs6'
        }, {
          model: 'color',
          rules: [],
          type: this.FORM_TYPE.COLORPICKER,
          class: 'md4 xs6',
          picker: 'colorPicker',
          menu: 'colorMenu',
          color: 'primary lighten-1',
          label: this.$t('message.common.color')
        }, /* {
          model: 'position',
          rules: [],
          type: this.FORM_TYPE.NUMBER,
          class: 'xs6',
          label: this.$t('message.common.position')
        },  */{
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.common.isDefault')
        }, {
          model: 'isopen',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.tickets.isOpen')
        }, {
          model: 'canclose',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.ticketStatus.canClose')
        }, {
          model: 'canreopen',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.tickets.canReOpen')
        }, {
          model: 'send_auto_reply',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.settings.sendAutoReply')
        }, {
          model: 'daystonotifystatusnotchanged',
          rules: [],
          type: this.FORM_TYPE.NUMBER,
          class: 'md4 xs6 my-auto',
          label: this.$t('message.tickets.daysToNotify')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = {
          type: 'TICKETSTATUS_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        let payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE_URL
      let queryFields = this.$formatter.cloneVariable(this.headers)
      let { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let query = {
        'order_by': {
          'field': sortBy.join(''),
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then((response) => {
          let { values, count } = response.data
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.listPayloadObj.page = 1
          }
        })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${id}`)
        .then((result) => {
          if (result.data) this.modelObj = result.data
          if (!this.modelObj.color) this.modelObj.color = ''
          this.dialog = true
          setTimeout(() => {
            this.reInit++
          }, 500)
        })
    },
    openDialogHandler () {
      this.dialog = true
      this.modelObj = { isactive: true, color: '#1976D2FF' }
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        model.position = model.position || null
        model.auto_reply = model.send_auto_reply ? model.auto_reply : ''
        let url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
